import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { CreateSupportTicketModalComponent } from '@features/support/modals/create-support-ticket-modal/create-support-ticket-modal.component';
import { ChatSupportTicketModalComponent } from '@features/support/modals/chat-support-ticket-modal/chat-support-ticket-modal.component';

export function provideSupportModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'CreateSupportTicketModal', component: CreateSupportTicketModalComponent, requiresAuth: true }, multi: true },
    { provide: MODAL_REGISTRY, useValue: { key: 'ChatSupportTicketModal', component: ChatSupportTicketModalComponent, requiresAuth: true }, multi: true },
  ];
}
